import styled from 'styled-components'

// Components
import Link from 'components/Link'

export const StyledLinkButton = styled(Link)`
  display: block;
  margin-top: 24px;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.small};
`
